<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Match Amex Transactions'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.MatchTransactions"
							>
								<div
									class="layout-block vertical"
									style="padding: 1rem; font-family: sans-serif"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<div
										class="layout-block"
										[style.align-items]="'center'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<div
											class="layout-block vertical"
											style="width: 100%"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<div
												class="layout-block block"
												[class]="'file-upload-card'"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<span
													[innerHtml]="'Upload transactions from Amex portal' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
												<ng-container *ngIf="!screen.fileTransactions"
													><app-file-upload
														class="has-filesSelected-handler"
														(filesSelected)="handler_FileUploadBlock_31_filesSelected_$adhoc_0($event, { $disabled: $disabled })"
														[multiple]="false"
														[allowedMimeTypes]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
														[disabled]="$disabled"
														displayStyle="dropZone"
														[uploadToServer]="false"
														color="basic"
													>
														<span
															[innerHtml]="'Click or drop XLSX file here to upload' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span> </app-file-upload
												></ng-container>

												<ng-container *ngIf="screen.fileTransactions"
													><span
														[innerHtml]="screen.fileTransactions?.name | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_35_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'clear'}}</mat-icon
														><span
															[innerHtml]="'Clear' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span></button
												></ng-container>
											</div>
										</div>
										<div
											class="layout-block vertical"
											style="width: 100%"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<div
												class="layout-block block"
												[class]="'file-upload-card'"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<span
													[innerHtml]="'Upload list of open invoices from NetSuite' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
												<ng-container *ngIf="!screen.fileInvoices"
													><app-file-upload
														class="has-filesSelected-handler"
														(filesSelected)="handler_FileUploadBlock_62_filesSelected_$adhoc_0($event, { $disabled: $disabled })"
														[multiple]="false"
														[allowedMimeTypes]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
														[disabled]="$disabled"
														displayStyle="dropZone"
														[uploadToServer]="false"
														color="basic"
													>
														<span
															[innerHtml]="'Click or drop XLSX file here to upload' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span> </app-file-upload
												></ng-container>

												<ng-container *ngIf="screen.fileInvoices"
													><span
														[innerHtml]="screen.fileInvoices?.name | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_65_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'clear'}}</mat-icon
														><span
															[innerHtml]="'Clear' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span></button
												></ng-container>
											</div>
										</div>
									</div>
									<div
										class="layout-block vertical"
										style="justify-content: center"
										[style.align-items]="'inherit'"
										[style.gap]="'1em'"
									>
										<div
											class="layout-block vertical"
											[style.align-items]="'center'"
											[style.gap]="'0.2em'"
										>
											<ng-container
												*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.fileInvoices || !screen.fileTransactions)) as $disabled"
											>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_36_click_$adhoc_0($event, { $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<span
														[innerHtml]="'Match' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</ng-container>
										</div>
									</div>
									<ng-container *ngIf="screen.matchResult"
										><div
											class="layout-block vertical"
											[class]="'result-card'"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<div
												class="layout-block"
												style="justify-content: center"
												[style.align-items]="'inherit'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<div
													class="layout-block vertical"
													style="text-align: center"
													[style.align-items]="'inherit'"
													[style.gap]="'1em'"
												>
													<span
														[innerHtml]="'RESULT' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
													<h2
														[style.color]="screen.matchResult?.unmatchedCount ? 'orange' : '#2e7d32'"
														[innerHtml]="`${screen.matchResult?.matchedCount} / ${screen.matchResult?.totalTransactions}` | escapeHtml: 'none' | replaceNewlines: 'h2'"
													></h2>
													<span
														[innerHtml]="'TRANSACTIONS MATCHED' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</div>
											</div>
											<div
												class="layout-block"
												[style.align-items]="'inherit'"
												[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.--layout-column-count]="2"
												[style.gap]="'1em'"
											>
												<div
													class="layout-block vertical"
													style="
														text-align: center;
														justify-content: center;
													"
													[style.grid-column]="'span ' + (1)"
													[style.align-items]="'inherit'"
													[style.gap]="'1em'"
												>
													<h2
														[innerHtml]="`${screen.matchResult?.matchPercentage}%` | escapeHtml: 'none' | replaceNewlines: 'h2'"
													></h2>
													<span
														[innerHtml]="'MATCHED' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</div>
												<div
													class="layout-block vertical"
													style="
														text-align: center;
														justify-content: center;
													"
													[style.grid-column]="'span ' + (1)"
													[style.align-items]="'inherit'"
													[style.gap]="'1em'"
												>
													<h2
														style="color: red"
														[innerHtml]="screen.matchResult?.unmatchedCount | escapeHtml: 'none' | replaceNewlines: 'h2'"
													></h2>
													<span
														[innerHtml]="'UNMATCHED' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</div>
											</div>
											<div
												class="layout-block"
												style="justify-content: center"
												[style.align-items]="'center'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_84_click_$adhoc_0($event, { $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'cloud_download'}}</mat-icon
													><span
														[innerHtml]="'Matched CSVs for Zone Reconcile' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_85_click_$adhoc_0($event, { $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'cloud_download'}}</mat-icon
													><span
														[innerHtml]="'Matching Report' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</div>
											<div
												class="layout-block vertical"
												style="margin: 1em"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<span
													[innerHtml]="'Next steps:' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
												<ul class="vertical">
													<li style="margin-bottom: 1em">
														<span
															[innerHtml]="'Download matched transactions in CSV format ready for import into Zone Reconcile' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</li>

													<li>
														<span
															[style.font-weight]="screen.matchResult.unmatchedCount ? 'bold' : ''"
															[innerHtml]="'In case of unmatched transactions, download the matching report to see, which transactions could not be matched' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</li>
												</ul>
											</div></div
									></ng-container>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
